import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class DisciplineTuitionFeeDeliveryMethodRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return (
			indexableFilters.length === 3 &&
			indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			indexableFilters.some((_) => _.type === ParameterType.TUITION_FEE) &&
			indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD)
		);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.DISCIPLINE_TUITION_FEE_DELIVERY_METHOD_ROUTE,
			params: {
				discipline: this.extractPath(filters.find((_) => _.type === ParameterType.DISCIPLINES)),
				tuition_fee: this.extractPath(filters.find((_) => _.type === ParameterType.TUITION_FEE)),
				delivery_method: this.extractPath(filters.find((_) => _.type === ParameterType.DELIVERY_METHOD)),
			},
		};
	}
}
